export const FIELD_KEYS = {
	PICKUP_DATE_FROM: 'pick-up-date-from',
	PICKUP_DATE_UNTIL: 'pick-up-date-until',
	DROP_DATE_FROM: 'drop-date-from',
	DROP_DATE_UNTIL: 'drop-date-until',
	PUBLISH_UNTIL: 'publish-until',
	PICKUP_REFERENCE: 'pick-up-reference',
	DROP_REFERENCE: 'drop-reference',
	PICKUP_LOCATION: 'pick-up-location',
	DROP_LOCATION: 'drop-location',
	PRICE: 'price',
	INVOICE_REFERENCE: 'invoice-reference',
	ACCEPTANCE_PRICE: 'acceptance-price',
	CARRIERS: 'carriers',
	PUBLISH: 'publish',
	UNPUBLISH: 'unpublish',
} as const;

export type FieldKey = (typeof FIELD_KEYS)[keyof typeof FIELD_KEYS];

export const DATE_FIELD_KEYS = [
	FIELD_KEYS.PICKUP_DATE_FROM,
	FIELD_KEYS.PICKUP_DATE_UNTIL,
	FIELD_KEYS.DROP_DATE_FROM,
	FIELD_KEYS.DROP_DATE_UNTIL,
	FIELD_KEYS.PUBLISH_UNTIL,
] as const;

export type DateFieldKey = (typeof DATE_FIELD_KEYS)[number];

export const PUBLISH_STATE_FIELD_KEYS = [
	FIELD_KEYS.PUBLISH,
	FIELD_KEYS.UNPUBLISH,
] as const;

export type PublishStateFieldKey = (typeof PUBLISH_STATE_FIELD_KEYS)[number];

export const isPublishStateFieldKey = (
	value: unknown,
): value is PublishStateFieldKey =>
	typeof value === 'string' &&
	(PUBLISH_STATE_FIELD_KEYS as readonly string[]).includes(value);

export const isFieldKey = (v: unknown): v is FieldKey =>
	typeof v === 'string' && Object.values(FIELD_KEYS).includes(v as FieldKey);
export const isDateFieldKey = (v: unknown): v is DateFieldKey =>
	typeof v === 'string' && (DATE_FIELD_KEYS as readonly string[]).includes(v);
